<mat-card class="cardWithShadow">
  <mat-tab-group dynamicHeight mat-stretch-tabs="false" animationDuration="0ms">
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="d-flex align-items-center">
          <mat-icon class="d-flex align-items-center">
            <i-tabler name="user-circle" class="icon-20 m-r-8 d-flex"></i-tabler>
          </mat-icon>
        </div>
        Account
      </ng-template>
      <app-account></app-account>
    </mat-tab>
<!--    <mat-tab>-->
<!--      <ng-template mat-tab-label>-->
<!--        <div class="d-flex align-items-center">-->
<!--          <mat-icon class="d-flex align-items-center">-->
<!--            <i-tabler name="bell" class="icon-20 m-r-8 d-flex"></i-tabler>-->
<!--          </mat-icon>-->
<!--        </div>-->
<!--        Notifications-->
<!--      </ng-template>-->
<!--    </mat-tab>-->
<!--    <mat-tab>-->
<!--      <ng-template mat-tab-label>-->
<!--        <div class="d-flex align-items-center">-->
<!--          <mat-icon class="d-flex align-items-center">-->
<!--            <i-tabler name="receipt" class="icon-20 m-r-8 d-flex"></i-tabler>-->
<!--          </mat-icon>-->
<!--        </div>-->
<!--        Bills-->
<!--      </ng-template>-->
<!--    </mat-tab>-->
<!--    <mat-tab>-->
<!--      <ng-template mat-tab-label>-->
<!--        <div class="d-flex align-items-center">-->
<!--          <mat-icon class="d-flex align-items-center">-->
<!--            <i-tabler name="lock" class="icon-20 m-r-8 d-flex"></i-tabler>-->
<!--          </mat-icon>-->
<!--        </div>-->
<!--        Security-->
<!--      </ng-template>-->
<!--      -->
<!--    </mat-tab>-->
  </mat-tab-group>
</mat-card>
